import { useAppState } from 'hooks/useAppState';
import { getMediaFlags } from 'utils/mediaQueryUtils';

export const useMediaFlags = () => {
  const { mediaQueryType } = useAppState();

  return getMediaFlags(mediaQueryType);
};
